import dealApiClient from './lib/client.js';
import addClientInstanceIdHeader from './lib/links/clientInstanceId.js';
import addExperimentOverridesHeader from './lib/links/experimentOverrides.js';
import addForceTraceHeader from './lib/links/forceTrace.js';
import addIsBotHeader from './lib/links/isBot.js';
import viewerContextLink from './lib/links/viewerContext.js';
import errorLink from './lib/links/errors.js';
import xsrfCookieToHeader from './lib/links/csrfHeader.js';
import expectedIdentity from './lib/links/expectedIdentity.js';
import recordOperation from './lib/links/recordOperation.js';

function getDomainName(hostname) {
    return hostname.split('.').slice(-2).join('.').toLowerCase();
}
function browserDealApiClient(_a) {
    var protocol = _a.protocol, host = _a.host, port = _a.port, cachePossibleTypes = _a.cachePossibleTypes, cacheNonNormalizableTypes = _a.cacheNonNormalizableTypes, cacheRelayStylePaginationFields = _a.cacheRelayStylePaginationFields, initialCacheState = _a.initialCacheState, experimentOverrides = _a.experimentOverrides, viewerContext = _a.viewerContext, onError = _a.onError, onGraphQLError = _a.onGraphQLError, onNetworkError = _a.onNetworkError, webSocketProtocol = _a.webSocketProtocol, links = _a.links, forceTrace = _a.forceTrace, isBot = _a.isBot, clientAwarenessName = _a.clientAwarenessName, clientAwarenessVersion = _a.clientAwarenessVersion, identityFromJwtPayload = _a.identityFromJwtPayload, identityFromCache = _a.identityFromCache, onIdentityMismatch = _a.onIdentityMismatch, recordOperationCallback = _a.recordOperation;
    if (getDomainName(host) !== getDomainName(window.location.hostname)) {
        console.warn("The client hostname (" + window.location.hostname + ") does not appear to match the API hostname (" + host + "). The API server may reject CORS requests!");
    }
    var client = dealApiClient({
        endpoint: protocol + "://" + host + ":" + port + "/graphql",
        webSocketEndpoint: webSocketProtocol
            ? webSocketProtocol + "://" + host + ":" + port + "/ws/graphql"
            : undefined,
        links: (links || [])
            .concat([
            addClientInstanceIdHeader(),
            xsrfCookieToHeader(),
            addExperimentOverridesHeader(experimentOverrides),
            addIsBotHeader(isBot),
            addForceTraceHeader(forceTrace),
            viewerContextLink(viewerContext),
            errorLink({ onError: onError, onNetworkError: onNetworkError, onGraphQLError: onGraphQLError }),
            expectedIdentity({
                getCache: function () { return client.apolloClient.cache; },
                getIdentityFromJwtPayload: identityFromJwtPayload,
                getIdentityFromCache: identityFromCache,
                onIdentityMismatch: onIdentityMismatch
            })
        ])
            .concat(recordOperationCallback ? [recordOperation(recordOperationCallback)] : []),
        cachePossibleTypes: cachePossibleTypes,
        cacheNonNormalizableTypes: cacheNonNormalizableTypes,
        cacheRelayStylePaginationFields: cacheRelayStylePaginationFields,
        initialCacheState: initialCacheState,
        viewerContext: viewerContext,
        experimentOverrides: experimentOverrides,
        clientAwarenessName: clientAwarenessName,
        clientAwarenessVersion: clientAwarenessVersion
    });
    return client;
}

export { browserDealApiClient };
//# sourceMappingURL=browser.js.map
